const ufeApi = require('services/api/ufeApi');
const urlUtils = require('utils/Url');
const catalogConstants = require('components/LegacyCatalog/constants');
const { handleSEOForCanada } = require('components/LegacyCatalog/utils');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Brand+Details+API

function getNthLevelBrand(options) {
    const {
        brandId,
        catalogId,
        ...opts
    } = options;
    const catalogService = Sephora.Util.InflatorComps.services.CatalogService;
    let url = `/api/catalog/brands/${brandId}`;

    // We should add a different parameter to the request depending on the page we are at:
    //  1. Brand all categories: we should add "products = all"
    //  2. Brand specific category: we should add "node = nodeId"
    if (catalogId === catalogConstants.ALL_CATEGORIES_SEO_NAME) {
        opts.products = catalogId;
    } else {
        opts.node = catalogId;
    }

    const constructorSessionID = !!global.ConstructorioTracker && global.ConstructorioTracker.getSessionID();
    const constructorClientID = !!global.ConstructorioTracker && global.ConstructorioTracker.getClientID();
    const isNLPCatalog = catalogService && catalogService.isNLPCatalog();
    const isNLPInstrumentationEnabled = Sephora.configurationSettings.isNLPInstrumentationEnabled;
    const getRefinement = function (){
        if (opts.ref && opts.ref.split(',').length) {
            opts.ref.split(',').forEach(refinement => url += `&ref=${refinement}`);
            delete opts.ref;
        }
    };
    
    if (isNLPInstrumentationEnabled){
        if (isNLPCatalog && constructorSessionID && constructorClientID) {
            url = url + `?constructorSessionID=${constructorSessionID}&constructorClientID=${constructorClientID}&targetSearchEngine=${catalogService.catalogEngine}`;
            getRefinement();
        }
    } else {
        url = url + `?targetSearchEngine=${catalogService.catalogEngine}`;
        getRefinement();
    }
    
       
    if (Object.keys(opts).length) {
        url += (isNLPCatalog ? '&' : '?') + urlUtils.makeQueryString(opts);
    }

    return ufeApi.makeRequest(url, { method: 'GET' }).
        then(data => {
            if (data.errorCode) {
                return Promise.reject(data);
            } else {
                catalogService.catalogEngine = data.responseSource;
                return handleSEOForCanada(data);
            }
        });
}

module.exports = getNthLevelBrand;
